export const twBar =
  'tw:flex tw:items-center tw:gap-3 tw:px-4 tw:py-2 ' +
  'tw:bg-[var(--color-surface-raised)] tw:border tw:border-[var(--color-border)] ' +
  'tw:rounded-[var(--radius-lg)] tw:shadow-[var(--shadow-md)]';

export const twCloseButton =
  'tw:flex tw:items-center tw:justify-center tw:w-8 tw:h-8 tw:rounded-full ' +
  'tw:text-[var(--color-text-secondary)] tw:hover:bg-[var(--color-surface-overlay)] ' +
  'tw:cursor-pointer tw:transition-colors';

export const twCount = 'tw:text-sm tw:font-medium tw:text-[var(--color-text-primary)] tw:whitespace-nowrap';

export const twActionsContainer = 'tw:flex tw:items-center tw:gap-1 tw:ml-auto';
